import { render, staticRenderFns } from "./TokenModal.vue?vue&type=template&id=3ade6ee9&scoped=true&"
import script from "./TokenModal.vue?vue&type=script&lang=js&"
export * from "./TokenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade6ee9",
  null
  
)

export default component.exports